import React, { useEffect, useState } from "react";
import axios from "axios";

const UpcomingEvents = ({ calendarId = "solidrockcathedral@gmail.com" }) => {
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchEvents = async () => {
            try {
                const response = await axios.get("/api/calendar/formatted-events", {
                    params: { calendarId, maxResults: 5 },
                });
                setEvents(response.data);
                setLoading(false);
            } catch (error) {
                console.error("Error fetching formatted events:", error);
                setLoading(false);
            }
        };

        fetchEvents();
    }, [calendarId]);

    if (loading) return <p>Loading upcoming events...</p>;
    if (!events.length) return <p>No upcoming events found.</p>;

    return (
        <div className="space-y-6">
            {events.map((event, index) => (
                <div
                    key={index}
                    className="border border-gray-200 rounded-lg p-4 shadow-lg"
                >
                    <h3 className="font-bold text-lg text-gray-800 mb-2">{event.title}</h3>
                    <p className="text-gray-600">{event.date}</p>
                    {event.description && (
                        <p className="text-gray-700 mt-2">{event.description}</p>
                    )}
                </div>
            ))}
        </div>
    );
};

export default UpcomingEvents;
